import { Reducer } from 'redux'
import { CountriesPageState, CountriesPageActionTypes } from './types'
import { translateCountries } from '../../utils/translate'
import { SelectableItemConverter } from '../../components/selectableItem/selectableItemConverters';

const initialState: CountriesPageState = {
	isVisible: false
}

const reducer: Reducer<CountriesPageState> = (state = initialState, action) => {
	switch (action.type) {
		case CountriesPageActionTypes.SHOW_CountriesPage: {
			return { ...state, isVisible: true }
		}
		case CountriesPageActionTypes.HIDE_CountriesPage: {
			return { ...state, isVisible: false }
		}
		default: {
			return state
		}
	}
}

export { reducer as countriesPageReducer }
